import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './BlogCard.css';

const BlogCard = ({ post }) => {
    const { lang } = useParams();

    return (
        <div className="blog-card-container">
            {post.featuredImage && (
                <div className="blog-card-image-wrapper">
                    <div
                        className="blog-card-image"
                        style={{ backgroundImage: `url(${post.featuredImage})` }}
                    ></div>
                </div>
            )}
            <div className="blog-card-content">
                <p className="blog-card-meta">
                    {new Date(post.date).toLocaleDateString()} • {post.author}
                </p>
                <Link to={`/${lang}/blog/${post.slug}`} className="blog-card-title-link">
                    <h2 className="blog-card-title">
                        {post.title}
                    </h2>
                </Link>
                <div
                    className="blog-card-excerpt"
                    dangerouslySetInnerHTML={{ __html: post.excerpt }}
                />
            </div>
        </div>
    );
};

export default BlogCard;
